<template lang="pug">
  .history-method
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container
        .history-label Method
        div {{ capitalize(dataOriginal.method) }}
      .history-container(v-if="dataOriginal.order")
        .history-label Order
        div {{ dataOriginal.order }}
      .history-container(v-if="dataOriginal.type")
        .history-label Type
        div {{ dataOriginal.type }}
      .history-container(v-if="dataOriginal.folder")
        .history-label Folder
        div {{ dataOriginal.folder }}
      .history-container(v-if="dataOriginal.image")
        .history-label Image
        div {{ dataOriginal.image }}
      .history-container(v-if="dataOriginal.active || dataOriginal.active === false")
        .history-label Active
        div {{ dataOriginal.active }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryUser',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-method
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/method/History.vue